export const get_domain_client = () => {
  return window?.location?.host;
};

export const get_env_domain_client = () => {
  return process.env.NEXT_PUBLIC_SITE_DOMAIN?.replace("http://", "")
    ?.replace("https://", "")
    ?.replace("/", "");
};

export const is_localhost_client = () => {
  const domain = get_domain_client();
  return !!(domain?.includes("localhost") || domain?.includes("127.0.0.1"));
};

export const get_protocol_client = () => {
  return window?.location?.protocol?.replace(":", "");
};

export const get_full_url_client = () => {
  return window?.location?.href;
};

export const get_pathname_client = () => {
  return String(window?.location?.pathname);
};

export const get_origin_client = () => {
  return window?.location?.origin;
};

//
// export const get_ip = async () => {
//     const FALLBACK_IP_ADDRESS = '0.0.0.0'
//     const headers_list = await headers();
//     const protocol = get_protocol();
//     return protocol ? protocol?.split(',')?.[0] ?? FALLBACK_IP_ADDRESS : headers_list?.get('x-real-ip') ?? FALLBACK_IP_ADDRESS;
// }
